import React, { createContext, useContext, useState, useMemo } from 'react'
import PropTypes from 'prop-types'

const RootContext = createContext()
export function RootProvider({ children }) {
  const [showFooter, setShowFooter] = useState(true)

  const value = useMemo(() => ({ setShowFooter, showFooter }), [setShowFooter, showFooter])

  return <RootContext.Provider value={value}>{children}</RootContext.Provider>
}

RootProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export function useRoot() {
  return useContext(RootContext)
}
